import { pluralize } from './string';

export const getFormattedDateYYYYMMDD = (date?: Date) => {
  const _date = date || new Date();
  const year = _date.getFullYear();
  const month = String(_date.getMonth() + 1).padStart(2, '0');
  const day = String(_date.getDate()).padStart(2, '0');
  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
};

// Format date to "M/d/yyyy · h:mm a" format (e.g. "8/12/2023 · 6:12 PM")
export const formatDateWithTime = (dateString?: string) => {
  if (!dateString) return '';

  try {
    const date = new Date(dateString);

    // Format date part: M/d/yyyy
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();

    // Format time part: h:mm a
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';

    // Convert hours to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // 0 should be displayed as 12

    return `${month}/${day}/${year} · ${hours}:${minutes} ${ampm}`;
  } catch (error) {
    return dateString;
  }
};

/**
 * Format date to "Day of Week, Month Day, h:mm:ss AM/PM" format (e.g. "Friday, May 9, 3:10:30 PM")
 * Used for test creation dates in the tests tab
 */
export const formatTestDate = (dateString?: string) => {
  if (!dateString) return '';

  try {
    const date = new Date(dateString);

    // Get day of week
    const daysOfWeek = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ];
    const dayOfWeek = daysOfWeek[date.getDay()];

    // Get month name
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    const month = months[date.getMonth()];

    // Get day of month
    const day = date.getDate();

    // Format time part: h:mm:ss a
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';

    // Convert hours to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // 0 should be displayed as 12

    return `${dayOfWeek}, ${month} ${day}, ${hours}:${minutes}:${seconds} ${ampm}`;
  } catch (error) {
    return dateString;
  }
};

export const timeAgo = (dateString: string) => {
  const date = new Date(dateString);
  const now = new Date();
  const secondsAgo = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (secondsAgo < 60) {
    return `${secondsAgo} ${pluralize('second', secondsAgo)} ago`;
  }

  const minutesAgo = Math.floor(secondsAgo / 60);
  if (minutesAgo < 60) {
    return `${minutesAgo} ${pluralize('minute', minutesAgo)} ago`;
  }

  const hoursAgo = Math.floor(minutesAgo / 60);
  if (hoursAgo < 24) {
    return `${hoursAgo} ${pluralize('hour', hoursAgo)} ago`;
  }

  const daysAgo = Math.floor(hoursAgo / 24);
  if (daysAgo < 30) {
    return `${daysAgo} ${pluralize('day', daysAgo)} ago`;
  }

  const monthsAgo = Math.floor(daysAgo / 30);
  if (monthsAgo < 12) {
    return `${monthsAgo} ${pluralize('month', monthsAgo)} ago`;
  }

  const yearsAgo = Math.floor(monthsAgo / 12);
  return `${yearsAgo} ${pluralize('year', yearsAgo)} ago`;
};
